import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Å tudirati Mlade zdravnike",
  "description": "",
  "published": "2007-06-06T00:00:00.000Z",
  "redirect_from": ["/blog/tudirati-mlade-zdravnike/swizec/195"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Zadnje dni študiram kot nor ampak to ni tako zanimivo, noÄete vedeti.`}</p>
    <p>{`Poleg uÄenja še gledam veliko prijetno ukradenih Mladih zdravnikov (Scrubs), ki bi jih ne bil ukradel, Äe bi naša televizija nanizanko lepo predvajala, sami so si krivi, da ne gledamo njihovih reklam. Šesta sezona je odliÄna in je morebiti celo moja najljubša. Vsebuje preÄudovit zgodbeni lok, ki se razteza Äez vse epizode. Na splošno se opazi, da so v vsaki naslednji sezoni epizode bolj medsebojno povezane.`}</p>
    <p>{`Zanimivo je opaziti kako so vsi mislili, da bo to zadnja sezona, saj je vse skupaj posuto z obujanjem spominov na zadnjih šest let skupnega Å¾ivljenja. Vsi pa vemo, da se v nanizankah to paÄ ne dogaja, Äe se le-te ne bliÅ¾ajo koncu. Veseli me, da bo še ena sezona.`}</p>
    <p>{`Ampak zakaj je bilo potrebno stvar konÄati na tako bednem mestu? Lakotim po sedmi sezoni pa je še niti snemati niso zaÄeli!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      